import { Globe } from "lucide-react";
import { useTranslation } from "react-i18next";
import * as styles from "./LanguageSwitcher.styles";

const LanguageSwitcher = () => {
  const { i18n, t } = useTranslation(["common", "components"]);

  const toggleLanguage = () => {
    i18n.changeLanguage(i18n.language === "bs" ? "en" : "bs");
  };

  const currentLang = i18n.language === "bs" ? "bs" : "en";

  return (
    <button
      onClick={toggleLanguage}
      className={styles.button}
      aria-label={t("components:toggleLanguage")}
      title={`Switch to ${currentLang === "bs" ? t("language.english") : t("language.bosnian")}`}
    >
      <Globe className={styles.iconH4_5W4_5} />
      <span className={styles.langLabel}>{currentLang}</span>
    </button>
  );
};

export { LanguageSwitcher };
export default LanguageSwitcher;
